import React, { useEffect, useState, useRef, Children, createElement, Component } from 'react';
import { motion, useInView } from 'framer-motion';
import { CountdownTimer } from '../components/CountdownTimer';
const PIXEL_ID = '666521186552257';
function initMetaPixel() {
  if ((window as any).fbq) return;
  const f = window as any;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as any[];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
}
function fbqTrack(event: string, data?: Record<string, any>) {
  const fbq = (window as any).fbq;
  if (fbq) {
    if (data) {
      fbq('track', event, data);
    } else {
      fbq('track', event);
    }
  }
}
// ─── SVG Icon Components ───────────────────────────────────────────────────────
function FlameIcon({
  className = 'w-5 h-5'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-20">
      <path d="M12 2C12 2 8 7 8 11C8 13.2 9.8 15 12 15C14.2 15 16 13.2 16 11C16 9.5 15.2 8.2 14 7.2C14.5 8.5 14 10 13 10.5C13 8.5 12 2 12 2Z" data-id="element-21" />
      <path d="M12 15C9.8 15 8 16.8 8 19C8 21.2 9.8 23 12 23C14.2 23 16 21.2 16 19C16 17.5 15.2 16.2 14 15.5C14 16.5 13.2 17.5 12 17.5C10.8 17.5 10 16.5 10 15.5C10.6 15.2 11.3 15 12 15Z" data-id="element-22" />
    </svg>;
}
function ThermometerIcon({
  className = 'w-5 h-5'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-23">
      <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z" data-id="element-24" />
    </svg>;
}
function ShieldIcon({
  className = 'w-5 h-5'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-25">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-26" />
    </svg>;
}
function CheckIcon({
  className = 'w-5 h-5'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-27">
      <polyline points="20 6 9 17 4 12" data-id="element-28" />
    </svg>;
}
function StarIcon({
  className = 'w-4 h-4'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-29">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-30" />
    </svg>;
}
function QuoteIcon({
  className = 'w-8 h-8'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" opacity="0.3" data-id="element-31">
      <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" data-id="element-32" />
      <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" data-id="element-33" />
    </svg>;
}
function ArrowRightIcon({
  className = 'w-5 h-5'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-34">
      <line x1="5" y1="12" x2="19" y2="12" data-id="element-35" />
      <polyline points="12 5 19 12 12 19" data-id="element-36" />
    </svg>;
}
function SmokeIcon({
  className = 'w-5 h-5'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-37">
      <path d="M8 21c0-3 2-3 2-6s-2-3-2-6" data-id="element-38" />
      <path d="M12 21c0-3 2-3 2-6s-2-3-2-6" data-id="element-39" />
      <path d="M16 21c0-3 2-3 2-6s-2-3-2-6" data-id="element-40" />
    </svg>;
}
function XIcon({
  className = 'w-4 h-4'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" data-id="element-41">
      <line x1="18" y1="6" x2="6" y2="18" data-id="element-42" />
      <line x1="6" y1="6" x2="18" y2="18" data-id="element-43" />
    </svg>;
}
function LockIcon({
  className = 'w-4 h-4'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-44">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-45" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-46" />
    </svg>;
}
function ChevronDownIcon({
  className = 'w-5 h-5'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-47">
      <polyline points="6 9 12 15 18 9" data-id="element-48" />
    </svg>;
}
function BookIcon({
  className = 'w-5 h-5'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-49">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" data-id="element-50" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" data-id="element-51" />
    </svg>;
}
// ─── Animation Variants ────────────────────────────────────────────────────────
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const fadeIn = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.6
    }
  }
};
// ─── Animated Section Wrapper ──────────────────────────────────────────────────
function AnimatedSection({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} variants={staggerContainer} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className={className} data-id="element-52">
      {children}
    </motion.div>;
}
// ─── FAQ Item ─────────────────────────────────────────────────────────────────
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="faq-item py-5" data-id="element-53">
      <button onClick={() => setOpen(!open)} className="w-full flex items-start justify-between gap-4 text-left group" aria-expanded={open} data-id="element-54">
        <span className="font-oswald text-lg md:text-xl font-semibold text-cream group-hover:text-amber-400 transition-colors duration-200" style={{
        fontFamily: 'Oswald, sans-serif',
        color: open ? '#faa307' : '#fdf0d5'
      }} data-id="element-55">
          {question}
        </span>
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0 mt-1 text-amber-500" data-id="element-56">
          <ChevronDownIcon className="w-5 h-5" data-id="element-57" />
        </motion.span>
      </button>
      <motion.div initial={false} animate={{
      height: open ? 'auto' : 0,
      opacity: open ? 1 : 0
    }} transition={{
      duration: 0.35,
      ease: [0.22, 1, 0.36, 1]
    }} style={{
      overflow: 'hidden'
    }} data-id="element-58">
        <p className="pt-4 text-base md:text-lg leading-relaxed" style={{
        color: '#b8a99a',
        fontFamily: 'Lato, sans-serif'
      }} data-id="element-59">
          {answer}
        </p>
      </motion.div>
    </div>;
}
// ─── Main Sales Page ───────────────────────────────────────────────────────────
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    (window as any).fbq('init', PIXEL_ID);
    fbqTrack('PageView');
  }, []);
  const handleAddToCart = () => {
    fbqTrack('AddToCart', {
      content_name: 'The Backyard Pitmaster Bundle',
      content_type: 'product',
      value: 9.99,
      currency: 'AUD'
    });
  };
  return <div className="w-full min-h-screen" style={{
    backgroundColor: '#0d0a06'
  }} data-id="element-60">
      {/* STICKY URGENCY BAR */}
      <div className="sticky-bar fixed top-0 left-0 right-0 z-50 py-2 px-4" style={{
      background: 'linear-gradient(90deg, #7f1d1d 0%, #991b1b 50%, #7f1d1d 100%)'
    }} data-id="element-61">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2" data-id="element-62">
          <div className="flex items-center gap-2 text-center sm:text-left" data-id="element-63">
            <FlameIcon className="w-4 h-4 text-amber-400 flex-shrink-0 flicker" data-id="element-64" />
            <p className="text-xs sm:text-sm font-bold text-white" style={{
            fontFamily: 'Lato, sans-serif'
          }} data-id="element-65">
              <span className="text-amber-300" data-id="element-66">FLASH SALE:</span> Get the
              Pitmaster's Bundle for{' '}
              <span className="text-amber-300" data-id="element-67">85% OFF</span> before the
              Memorial Day price hike.
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0" data-id="element-68">
            <CountdownTimer initialSeconds={862} compact data-id="element-69" />
            <a href="#offer" className="btn-gold text-xs px-3 py-1.5 rounded font-bold whitespace-nowrap" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-70">
              CLAIM 85% OFF
            </a>
          </div>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="relative min-h-screen flex items-center justify-center pt-10" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/gu5rpFEYa1gekLmPLJXrAH/BANNER_PM.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center top'
    }} data-id="element-71">
        {/* Dark overlay */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to right, rgba(0,0,0,0.88) 0%, rgba(13,10,6,0.75) 50%, rgba(0,0,0,0.5) 100%)'
      }} data-id="element-72" />
        {/* Bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-40" style={{
        background: 'linear-gradient(to bottom, transparent, #0d0a06)'
      }} data-id="element-73" />

        <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 text-center md:text-left" data-id="element-74">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-75">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 mb-6" data-id="element-76">
              <FlameIcon className="w-4 h-4 text-amber-400" data-id="element-77" />
              <span className="text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full border" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#faa307',
              borderColor: 'rgba(250,163,7,0.4)',
              backgroundColor: 'rgba(250,163,7,0.1)',
              letterSpacing: '0.2em'
            }} data-id="element-78">
                The 2026 Heat-Flow System
              </span>
            </div>

            {/* Main Headline */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#fdf0d5',
            lineHeight: 1.05
          }} data-id="element-79">
              How to Master Texas-Quality BBQ
              <br data-id="element-80" />
              <span style={{
              color: '#fdf0d5'
            }} data-id="element-81">
                on the $99 Grill
              </span>{' '}
              <span style={{
              color: '#f48c06'
            }} data-id="element-82">
                You Already Own
              </span>
            </h1>

            {/* Sub-headline */}
            <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-8 max-w-3xl" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#e85d04',
            lineHeight: 1.3
          }} data-id="element-83">
              — Even If You've Ruined Every Brisket You've Ever Touched.
            </h2>

            {/* Body intro */}
            <p className="text-base md:text-lg max-w-2xl mb-10 leading-relaxed" style={{
            fontFamily: 'Lato, sans-serif',
            color: '#b8a99a'
          }} data-id="element-84">
              Stop guessing. Stop wasting $120 on dry meat. Discover the system
              that turns any backyard amateur into the neighborhood's undisputed
              Pitmaster in{' '}
              <strong style={{
              color: '#fdf0d5'
            }} data-id="element-85">
                30 days or less.
              </strong>
            </p>

            {/* Hero CTA */}
            <div className="flex flex-col sm:flex-row items-center md:items-start gap-4" data-id="element-86">
              <a href="#offer" className="btn-gold text-base md:text-lg px-8 py-4 rounded-lg inline-flex items-center gap-3 gold-glow" data-id="element-87">
                <FlameIcon className="w-5 h-5" data-id="element-88" /> YES — MASTER THE SMOKE FOR
                $9.99 AUD
                <ArrowRightIcon className="w-5 h-5" data-id="element-89" />
              </a>

              <div className="flex items-center gap-2" style={{
              color: '#b8a99a',
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.85rem'
            }} data-id="element-90">
                <LockIcon className="w-4 h-4" data-id="element-91" />
                <span data-id="element-92">Secure checkout · 60-day guarantee</span>
              </div>
            </div>

            {/* Social proof mini */}
            <div className="flex items-center gap-3 mt-8" data-id="element-93">
              <div className="flex" data-id="element-94">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-amber-400" data-id="element-95" />)}
              </div>
              <span style={{
              color: '#b8a99a',
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.85rem'
            }} data-id="element-96">
                <strong style={{
                color: '#fdf0d5'
              }} data-id="element-97">
                  4,812 pitmasters
                </strong>{' '}
                already mastered the flame
              </span>
            </div>
          </motion.div>
        </div>
      </section>

      {/* SECTION 1: THE HOOK — 6PM SCENARIO */}
      <section className="grain-overlay py-20 px-6" style={{
      backgroundColor: '#110e08'
    }} data-id="element-98">
        <div className="max-w-3xl mx-auto" data-id="element-99">
          <AnimatedSection data-id="element-100">
            <motion.div variants={fadeUp} data-id="element-101">
              <p className="section-label text-center mb-4" data-id="element-102">Sound Familiar?</p>
              <div className="divider-flame mb-10" data-id="element-103" />
            </motion.div>

            <motion.div variants={fadeUp} className="rounded-2xl p-8 md:p-12 relative overflow-hidden" style={{
            background: 'linear-gradient(135deg, #1e1509 0%, #150f06 100%)',
            border: '1px solid #2e2010'
          }} data-id="element-104">
              {/* Decorative ember dot */}
              <div className="absolute top-6 right-6 w-3 h-3 rounded-full pulse-ember" style={{
              backgroundColor: '#e85d04',
              boxShadow: '0 0 12px #e85d04'
            }} data-id="element-105" />

              <h2 className="text-3xl md:text-4xl font-bold mb-8" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-106">
                It's 6:00 PM. Your guests are staring.
              </h2>

              <div className="space-y-5" style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '1.1rem',
              lineHeight: 1.8,
              color: '#b8a99a'
            }} data-id="element-107">
                <p data-id="element-108">
                  Your father-in-law is{' '}
                  <em style={{
                  color: '#fdf0d5'
                }} data-id="element-109">
                    "checking"
                  </em>{' '}
                  the meat. And you? You're sweating through your shirt because
                  you just realized your brisket feels like a truck tire.
                </p>
                <p data-id="element-110">
                  You spent{' '}
                  <strong style={{
                  color: '#fdf0d5'
                }} data-id="element-111">
                    14 hours awake
                  </strong>
                  , smelled like a campfire, and now you're about to fail in
                  front of everyone you care about.
                </p>
                <p style={{
                color: '#fdf0d5',
                fontWeight: 700,
                fontSize: '1.2rem'
              }} data-id="element-112">
                  That moment of dread? We're going to make sure it never
                  happens again.
                </p>
              </div>
            </motion.div>
          </AnimatedSection>
        </div>
      </section>

      {/* SECTION 2: PAIN AGITATION */}
      <section className="py-20 px-6" style={{
      backgroundColor: '#0d0a06'
    }} data-id="element-113">
        <div className="max-w-4xl mx-auto" data-id="element-114">
          <AnimatedSection data-id="element-115">
            <motion.div variants={fadeUp} className="text-center mb-14" data-id="element-116">
              <p className="section-label mb-3" data-id="element-117">The Painful Truth</p>
              <h2 className="text-3xl md:text-5xl font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-118">
                Why Your BBQ Keeps Failing
              </h2>
              <div className="divider-flame mt-6" data-id="element-119" />
            </motion.div>

            <motion.div variants={fadeUp} className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-120">
              {/* Pain card 1 */}
              <div className="rounded-xl p-6" style={{
              background: '#1a1008',
              border: '1px solid #2e2010'
            }} data-id="element-121">
                <div className="flex items-start gap-3 mb-3" data-id="element-122">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center" style={{
                  backgroundColor: 'rgba(232,93,4,0.15)'
                }} data-id="element-123">
                    <XIcon className="w-4 h-4 text-red-500" data-id="element-124" />
                  </div>
                  <h3 className="text-lg font-bold" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#fdf0d5'
                }} data-id="element-125">
                    The $150 Costco Mistake
                  </h3>
                </div>
                <p style={{
                fontFamily: 'Lato, sans-serif',
                color: '#b8a99a',
                lineHeight: 1.7
              }} data-id="element-126">
                  You buy the most expensive Prime brisket. You spend all night
                  managing vents. You follow a random YouTube expert. And yet —
                  dry, grey, and bitter.
                </p>
              </div>

              {/* Pain card 2 */}
              <div className="rounded-xl p-6" style={{
              background: '#1a1008',
              border: '1px solid #2e2010'
            }} data-id="element-127">
                <div className="flex items-start gap-3 mb-3" data-id="element-128">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center" style={{
                  backgroundColor: 'rgba(232,93,4,0.15)'
                }} data-id="element-129">
                    <XIcon className="w-4 h-4 text-red-500" data-id="element-130" />
                  </div>
                  <h3 className="text-lg font-bold" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#fdf0d5'
                }} data-id="element-131">
                    The Sauce Cover-Up
                  </h3>
                </div>
                <p style={{
                fontFamily: 'Lato, sans-serif',
                color: '#b8a99a',
                lineHeight: 1.7
              }} data-id="element-132">
                  The look on your friends' faces when they have to drench your
                  BBQ in sauce just to swallow it. The quiet embarrassment of
                  being "the guy with the expensive grill who can't cook."
                </p>
              </div>

              {/* Pain card 3 */}
              <div className="rounded-xl p-6" style={{
              background: '#1a1008',
              border: '1px solid #2e2010'
            }} data-id="element-133">
                <div className="flex items-start gap-3 mb-3" data-id="element-134">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center" style={{
                  backgroundColor: 'rgba(232,93,4,0.15)'
                }} data-id="element-135">
                    <XIcon className="w-4 h-4 text-red-500" data-id="element-136" />
                  </div>
                  <h3 className="text-lg font-bold" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#fdf0d5'
                }} data-id="element-137">
                    The "Set and Forget" Lie
                  </h3>
                </div>
                <p style={{
                fontFamily: 'Lato, sans-serif',
                color: '#b8a99a',
                lineHeight: 1.7
              }} data-id="element-138">
                  You're tired of the pellet grill company promises. You want
                  real smoke, real bark, and that legendary Texas jiggle — not
                  mediocre results from a machine.
                </p>
              </div>

              {/* Pain card 4 */}
              <div className="rounded-xl p-6" style={{
              background: '#1a1008',
              border: '1px solid #2e2010'
            }} data-id="element-139">
                <div className="flex items-start gap-3 mb-3" data-id="element-140">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center" style={{
                  backgroundColor: 'rgba(232,93,4,0.15)'
                }} data-id="element-141">
                    <XIcon className="w-4 h-4 text-red-500" data-id="element-142" />
                  </div>
                  <h3 className="text-lg font-bold" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#fdf0d5'
                }} data-id="element-143">
                    The Saturday Sacrifice
                  </h3>
                </div>
                <p style={{
                fontFamily: 'Lato, sans-serif',
                color: '#b8a99a',
                lineHeight: 1.7
              }} data-id="element-144">
                  You threw $150 and your entire Saturday into the trash. That
                  stabbing pain when you realize the time, the money, the sleep
                  — all wasted on another failed cook.
                </p>
              </div>
            </motion.div>

            <motion.div variants={fadeUp} className="text-center" data-id="element-145">
              <p className="text-xl md:text-2xl font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#e85d04'
            }} data-id="element-146">
                It's not your fault. You were never taught the science.
              </p>
            </motion.div>
          </AnimatedSection>
        </div>
      </section>

      {/* SECTION 3: THE REVELATION */}
      <section className="grain-overlay py-20 px-6" style={{
      backgroundColor: '#110e08'
    }} data-id="element-147">
        <div className="max-w-4xl mx-auto" data-id="element-148">
          <AnimatedSection data-id="element-149">
            <motion.div variants={fadeUp} className="text-center mb-14" data-id="element-150">
              <p className="section-label mb-3" data-id="element-151">The Revelation</p>
              <h2 className="text-3xl md:text-5xl font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-152">
                BBQ Isn't About Recipes.
                <br data-id="element-153" />
                <span style={{
                color: '#f48c06'
              }} data-id="element-154">
                  It's About Thermodynamics.
                </span>
              </h2>
              <div className="divider-flame mt-6" data-id="element-155" />
            </motion.div>

            <motion.div variants={fadeUp} className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-156">
              <div className="text-center p-6" data-id="element-157">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{
                backgroundColor: 'rgba(232,93,4,0.15)',
                border: '1px solid rgba(232,93,4,0.3)'
              }} data-id="element-158">
                  <FlameIcon className="w-8 h-8 text-ember" style={{
                  color: '#e85d04'
                }} data-id="element-159" />
                </div>
                <h3 className="text-xl font-bold mb-3" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#fdf0d5'
              }} data-id="element-160">
                  Boundary Layer Control
                </h3>
                <p style={{
                fontFamily: 'Lato, sans-serif',
                color: '#b8a99a',
                lineHeight: 1.7,
                fontSize: '0.95rem'
              }} data-id="element-161">
                  The invisible layer of air around your meat determines bark
                  formation. Master it and you control the crust.
                </p>
              </div>

              <div className="text-center p-6" data-id="element-162">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{
                backgroundColor: 'rgba(244,140,6,0.15)',
                border: '1px solid rgba(244,140,6,0.3)'
              }} data-id="element-163">
                  <ThermometerIcon className="w-8 h-8" style={{
                  color: '#f48c06'
                }} data-id="element-164" />
                </div>
                <h3 className="text-xl font-bold mb-3" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#fdf0d5'
              }} data-id="element-165">
                  Interstitial Fat Rendering
                </h3>
                <p style={{
                fontFamily: 'Lato, sans-serif',
                color: '#b8a99a',
                lineHeight: 1.7,
                fontSize: '0.95rem'
              }} data-id="element-166">
                  The fat between muscle fibers must liquefy at the right rate.
                  This is what creates that legendary Texas jiggle.
                </p>
              </div>

              <div className="text-center p-6" data-id="element-167">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{
                backgroundColor: 'rgba(201,168,76,0.15)',
                border: '1px solid rgba(201,168,76,0.3)'
              }} data-id="element-168">
                  <SmokeIcon className="w-8 h-8" style={{
                  color: '#c9a84c'
                }} data-id="element-169" />
                </div>
                <h3 className="text-xl font-bold mb-3" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#fdf0d5'
              }} data-id="element-170">
                  Heat-Flow Architecture
                </h3>
                <p style={{
                fontFamily: 'Lato, sans-serif',
                color: '#b8a99a',
                lineHeight: 1.7,
                fontSize: '0.95rem'
              }} data-id="element-171">
                  How heat moves through your grill is the master variable. Once
                  you see it, you can replicate $5,000 smoker results on a Weber
                  kettle.
                </p>
              </div>
            </motion.div>

            <motion.div variants={fadeUp} className="rounded-2xl p-8 md:p-10 text-center" style={{
            background: 'linear-gradient(135deg, rgba(232,93,4,0.08) 0%, rgba(201,168,76,0.08) 100%)',
            border: '1px solid rgba(201,168,76,0.2)'
          }} data-id="element-172">
              <p className="text-xl md:text-2xl leading-relaxed" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-173">
                "Once I mastered the science of heat-flow, I realized I could
                make world-class BBQ on a cheap Weber kettle. I stopped being a
                cook and became a{' '}
                <strong style={{
                color: '#faa307',
                fontFamily: 'Oswald, sans-serif',
                fontSize: '1.3em'
              }} data-id="element-174">
                  Pitmaster
                </strong>
                . And today, I'm handing you that exact blueprint."
              </p>
            </motion.div>
          </AnimatedSection>
        </div>
      </section>

      {/* SECTION 4: SOCIAL PROOF / TESTIMONIALS */}
      <section className="py-20 px-6" style={{
      backgroundColor: '#0d0a06'
    }} data-id="element-175">
        <div className="max-w-5xl mx-auto" data-id="element-176">
          <AnimatedSection data-id="element-177">
            <motion.div variants={fadeUp} className="text-center mb-14" data-id="element-178">
              <p className="section-label mb-3" data-id="element-179">Real Results</p>
              <h2 className="text-3xl md:text-5xl font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-180">
                From Rubbish Ribs to Neighborhood Legend
              </h2>
              <div className="divider-flame mt-6" data-id="element-181" />
            </motion.div>

            <motion.div variants={staggerContainer} className="grid md:grid-cols-2 gap-6" data-id="element-182">
              {/* Testimonial 1 */}
              <motion.div variants={fadeUp} className="testimonial-card rounded-2xl p-8 relative" data-id="element-183">
                <QuoteIcon className="w-10 h-10 absolute top-6 right-6" data-id="element-184" />
                <div className="flex mb-4" data-id="element-185">
                  {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-amber-400" data-id="element-186" />)}
                </div>
                <p className="text-base md:text-lg mb-6 leading-relaxed" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#fdf0d5'
              }} data-id="element-187">
                  "I was the 'rubbish ribs' guy in my neighborhood for years.
                  After using the Smoke Physics chapter, I{' '}
                  <strong style={{
                  color: '#faa307'
                }} data-id="element-188">
                    won my first local cook-off
                  </strong>{' '}
                  using a grill I found at a garage sale. My wife actually wants
                  me to cook every weekend now!"
                </p>
                <div className="flex items-center gap-3" data-id="element-189">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm" style={{
                  backgroundColor: '#e85d04',
                  color: '#0d0a06',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-190">
                    JM
                  </div>
                  <div data-id="element-191">
                    <p className="font-bold text-sm" style={{
                    fontFamily: 'Oswald, sans-serif',
                    color: '#fdf0d5'
                  }} data-id="element-192">
                      Jason M. — Austin, TX
                    </p>
                    <p className="text-xs" style={{
                    color: '#e85d04',
                    fontFamily: 'Lato, sans-serif'
                  }} data-id="element-193">
                      Mastered Brisket in 21 days
                    </p>
                  </div>
                </div>
              </motion.div>

              {/* Testimonial 2 */}
              <motion.div variants={fadeUp} className="testimonial-card rounded-2xl p-8 relative" data-id="element-194">
                <QuoteIcon className="w-10 h-10 absolute top-6 right-6" data-id="element-195" />
                <div className="flex mb-4" data-id="element-196">
                  {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-amber-400" data-id="element-197" />)}
                </div>
                <p className="text-base md:text-lg mb-6 leading-relaxed" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#fdf0d5'
              }} data-id="element-198">
                  "The Brisket Rescue 911 bonus literally saved my anniversary
                  dinner. My meat was stalling and dry, I followed the 'Gold
                  Broth' protocol, and{' '}
                  <strong style={{
                  color: '#faa307'
                }} data-id="element-199">
                    my guests thought I was a pro
                  </strong>
                  . Best $9.99 AUD I've ever spent."
                </p>
                <div className="flex items-center gap-3" data-id="element-200">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm" style={{
                  backgroundColor: '#c9a84c',
                  color: '#0d0a06',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-201">
                    DR
                  </div>
                  <div data-id="element-202">
                    <p className="font-bold text-sm" style={{
                    fontFamily: 'Oswald, sans-serif',
                    color: '#fdf0d5'
                  }} data-id="element-203">
                      David R. — Charlotte, NC
                    </p>
                    <p className="text-xs" style={{
                    color: '#e85d04',
                    fontFamily: 'Lato, sans-serif'
                  }} data-id="element-204">
                      Saved a $130 Prime Brisket
                    </p>
                  </div>
                </div>
              </motion.div>
            </motion.div>

            {/* Trust bar */}
            <motion.div variants={fadeUp} className="mt-12 flex flex-wrap justify-center gap-8" data-id="element-205">
              <div className="flex items-center gap-2" style={{
              color: '#b8a99a',
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.9rem'
            }} data-id="element-206">
                <CheckIcon className="w-4 h-4 text-amber-500" data-id="element-207" />
                <span data-id="element-208">4,812+ students</span>
              </div>
              <div className="flex items-center gap-2" style={{
              color: '#b8a99a',
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.9rem'
            }} data-id="element-209">
                <CheckIcon className="w-4 h-4 text-amber-500" data-id="element-210" />
                <span data-id="element-211">4.9/5 average rating</span>
              </div>
              <div className="flex items-center gap-2" style={{
              color: '#b8a99a',
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.9rem'
            }} data-id="element-212">
                <CheckIcon className="w-4 h-4 text-amber-500" data-id="element-213" />
                <span data-id="element-214">60-day money-back guarantee</span>
              </div>
              <div className="flex items-center gap-2" style={{
              color: '#b8a99a',
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.9rem'
            }} data-id="element-215">
                <CheckIcon className="w-4 h-4 text-amber-500" data-id="element-216" />
                <span data-id="element-217">Works on any grill</span>
              </div>
            </motion.div>
          </AnimatedSection>
        </div>
      </section>

      {/* SECTION 5: OFFER PRESENTATION */}
      <section id="offer" className="grain-overlay py-20 px-6" style={{
      backgroundColor: '#110e08'
    }} data-id="element-218">
        <div className="max-w-5xl mx-auto" data-id="element-219">
          <AnimatedSection data-id="element-220">
            <motion.div variants={fadeUp} className="text-center mb-14" data-id="element-221">
              <p className="section-label mb-3" data-id="element-222">The Complete System</p>
              <h2 className="text-3xl md:text-5xl font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-223">
                Introducing: The Backyard
                <br data-id="element-224" />
                <span style={{
                color: '#faa307'
              }} data-id="element-225">
                  Pitmaster Bundle
                </span>
              </h2>
              <p className="mt-4 text-lg" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#b8a99a'
            }} data-id="element-226">
                Everything you need to conquer the flame — starting today.
              </p>
              <div className="divider-flame mt-6" data-id="element-227" />
            </motion.div>

            <div className="grid md:grid-cols-2 gap-10 items-start" data-id="element-228">
              {/* Product Image */}
              <motion.div variants={fadeUp} className="flex justify-center" data-id="element-229">
                <div className="relative" data-id="element-230">
                  <div className="absolute inset-0 rounded-2xl blur-3xl" style={{
                  backgroundColor: 'rgba(201,168,76,0.15)',
                  transform: 'scale(0.9) translateY(10%)'
                }} data-id="element-231" />
                  <img src="https://cdn.magicpatterns.com/uploads/rsGomr2MxjQHB2TrsP7wVJ/BPM_IMG_PRODUCT.png" alt="The Backyard Pitmaster Bundle — book, tablet, and phone mockup" className="relative rounded-2xl w-full max-w-md" style={{
                  boxShadow: '0 20px 60px rgba(0,0,0,0.6)'
                }} data-id="element-232" />
                </div>
              </motion.div>

              {/* Value Stack */}
              <motion.div variants={fadeUp} data-id="element-233">
                <div className="rounded-2xl overflow-hidden" style={{
                border: '1px solid #2e2010'
              }} data-id="element-234">
                  {/* Header */}
                  <div className="px-6 py-4" style={{
                  background: 'linear-gradient(90deg, #e85d04, #f48c06)',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-235">
                    <p className="text-sm font-bold tracking-widest uppercase text-black opacity-80" data-id="element-236">
                      What You Get Today
                    </p>
                  </div>

                  {/* Items */}
                  <div style={{
                  backgroundColor: '#1a1008'
                }} data-id="element-237">
                    <div className="value-item px-6 py-4 flex items-start justify-between gap-4" data-id="element-238">
                      <div className="flex items-start gap-3" data-id="element-239">
                        <BookIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                        color: '#faa307'
                      }} data-id="element-240" />
                        <div data-id="element-241">
                          <p className="font-bold text-sm" style={{
                          fontFamily: 'Oswald, sans-serif',
                          color: '#fdf0d5'
                        }} data-id="element-242">
                            Main Guide: The Backyard Pitmaster
                          </p>
                          <p className="text-xs mt-0.5" style={{
                          color: '#b8a99a',
                          fontFamily: 'Lato, sans-serif'
                        }} data-id="element-243">
                            The 30-day "Heat-Flow" Blueprint
                          </p>
                        </div>
                      </div>
                      <span className="text-sm font-bold flex-shrink-0" style={{
                      fontFamily: 'Oswald, sans-serif',
                      color: '#c9a84c'
                    }} data-id="element-244">
                        $75
                      </span>
                    </div>

                    {/* Total */}
                    <div className="px-6 py-5 flex items-center justify-between" style={{
                    background: 'rgba(201,168,76,0.08)',
                    borderTop: '1px solid rgba(201,168,76,0.2)'
                  }} data-id="element-245">
                      <div data-id="element-246">
                        <p className="text-xs uppercase tracking-widest mb-1" style={{
                        color: '#b8a99a',
                        fontFamily: 'Lato, sans-serif'
                      }} data-id="element-247">
                          Total Value
                        </p>
                        <p className="text-2xl font-bold" style={{
                        fontFamily: 'Oswald, sans-serif',
                        color: '#c9a84c'
                      }} data-id="element-248">
                          $75
                        </p>
                      </div>
                      <div className="text-right" data-id="element-249">
                        <p className="text-xs uppercase tracking-widest mb-1" style={{
                        color: '#b8a99a',
                        fontFamily: 'Lato, sans-serif'
                      }} data-id="element-250">
                          Today Only
                        </p>
                        <p className="text-3xl font-bold" style={{
                        fontFamily: 'Oswald, sans-serif',
                        color: '#faa307'
                      }} data-id="element-251">
                          $9.99 AUD
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* SECTION 6: PRICE + URGENCY CTA */}
      <section className="py-20 px-6 relative overflow-hidden" style={{
      backgroundColor: '#0d0a06'
    }} data-id="element-252">
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full blur-3xl pointer-events-none" style={{
        backgroundColor: 'rgba(232,93,4,0.08)'
      }} data-id="element-253" />

        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-254">
          <AnimatedSection data-id="element-255">
            <motion.div variants={fadeUp} data-id="element-256">
              <p className="section-label mb-3" data-id="element-257">Limited Time Offer</p>
              <h2 className="text-3xl md:text-5xl font-bold mb-4" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-258">
                This Price Disappears When the Timer Hits Zero.
              </h2>
              <p className="text-lg mb-8" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#b8a99a'
            }} data-id="element-259">
                I'm on a mission to end "Dry Brisket Syndrome" in America. No
                exceptions.
              </p>

              {/* Price display */}
              <div className="flex items-center justify-center gap-6 mb-8" data-id="element-260">
                <div className="text-center" data-id="element-261">
                  <p className="text-sm uppercase tracking-widest mb-1" style={{
                  color: '#b8a99a',
                  fontFamily: 'Lato, sans-serif'
                }} data-id="element-262">
                    Normal Price
                  </p>
                  <p className="text-3xl font-bold price-strike" style={{
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-263">
                    $75 AUD
                  </p>
                </div>
                <div className="w-px h-16" style={{
                backgroundColor: '#2e2010'
              }} data-id="element-264" />
                <div className="text-center" data-id="element-265">
                  <p className="text-sm uppercase tracking-widest mb-1" style={{
                  color: '#e85d04',
                  fontFamily: 'Lato, sans-serif'
                }} data-id="element-266">
                    Today Only
                  </p>
                  <p className="text-5xl font-bold" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#faa307'
                }} data-id="element-267">
                    $9.99 AUD
                  </p>
                </div>
                <div className="w-px h-16" style={{
                backgroundColor: '#2e2010'
              }} data-id="element-268" />
                <div className="text-center" data-id="element-269">
                  <p className="text-sm uppercase tracking-widest mb-1" style={{
                  color: '#b8a99a',
                  fontFamily: 'Lato, sans-serif'
                }} data-id="element-270">
                    You Save
                  </p>
                  <p className="text-3xl font-bold" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#c9a84c'
                }} data-id="element-271">
                    $65
                  </p>
                </div>
              </div>

              {/* Countdown */}
              <div className="flex justify-center mb-8" data-id="element-272">
                <div className="inline-flex items-center gap-4 px-6 py-4 rounded-xl" style={{
                backgroundColor: '#1a1008',
                border: '1px solid #2e2010'
              }} data-id="element-273">
                  <p className="text-sm font-bold uppercase tracking-wider" style={{
                  color: '#e85d04',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-274">
                    Offer Expires In:
                  </p>
                  <CountdownTimer initialSeconds={862} data-id="element-275" />
                </div>
              </div>

              {/* Main CTA */}
              <a href="https://www.versastorex.com/cart/42212433526864:1" onClick={handleAddToCart} className="btn-gold text-lg md:text-xl px-10 py-5 rounded-xl inline-flex items-center gap-3 gold-glow mb-4" data-id="element-276">
                <FlameIcon className="w-6 h-6" data-id="element-277" />
                YES — MASTER THE SMOKE. ACCESS NOW FOR $9.99 AUD
                <ArrowRightIcon className="w-6 h-6" data-id="element-278" />
              </a>

              <div className="flex flex-wrap items-center justify-center gap-4 mt-4" data-id="element-279">
                <div className="flex items-center gap-2" style={{
                color: '#b8a99a',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.85rem'
              }} data-id="element-280">
                  <LockIcon className="w-4 h-4" data-id="element-281" />
                  <span data-id="element-282">256-bit SSL Secure Checkout</span>
                </div>
                <div className="flex items-center gap-2" style={{
                color: '#b8a99a',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.85rem'
              }} data-id="element-283">
                  <ShieldIcon className="w-4 h-4" data-id="element-284" />
                  <span data-id="element-285">60-Day Money-Back Guarantee</span>
                </div>
                <div className="flex items-center gap-2" style={{
                color: '#b8a99a',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.85rem'
              }} data-id="element-286">
                  <CheckIcon className="w-4 h-4" data-id="element-287" />
                  <span data-id="element-288">Instant Digital Access</span>
                </div>
              </div>
            </motion.div>
          </AnimatedSection>
        </div>
      </section>

      {/* SECTION 7: FAQ / OBJECTION HANDLING */}
      <section className="grain-overlay py-20 px-6" style={{
      backgroundColor: '#110e08'
    }} data-id="element-289">
        <div className="max-w-3xl mx-auto" data-id="element-290">
          <AnimatedSection data-id="element-291">
            <motion.div variants={fadeUp} className="text-center mb-14" data-id="element-292">
              <p className="section-label mb-3" data-id="element-293">Got Questions?</p>
              <h2 className="text-3xl md:text-5xl font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-294">
                We've Got Answers
              </h2>
              <div className="divider-flame mt-6" data-id="element-295" />
            </motion.div>

            <motion.div variants={fadeUp} className="rounded-2xl overflow-hidden" style={{
            border: '1px solid #2e2010',
            backgroundColor: '#1a1008'
          }} data-id="element-296">
              <div className="px-6 md:px-8" data-id="element-297">
                <FaqItem question="I only have a cheap pellet grill or charcoal grill. Will this work?" answer="Absolutely. In fact, this was built specifically for you. We show you how to optimize 'budget' rigs to outperform expensive pro smokers. The Heat-Flow system is grill-agnostic — it works on any setup." data-id="element-298" />
                <FaqItem question="Is this just another recipe book?" answer="No. It's a science-based system. You'll learn to read the smoke and the meat, so you don't even need a recipe. Once you understand the principles, you can cook anything — without following instructions." data-id="element-299" />
                <FaqItem question="I'm a complete beginner. Is it too advanced for me?" answer="We start from absolute zero. If you can light a match, you can follow this system. The first module is specifically designed for people who have never smoked meat before." data-id="element-300" />
                <FaqItem question="How is this different from YouTube tutorials?" answer="YouTube teaches you what to do. We teach you why the meat reacts the way it does. That's the difference between following a recipe and actually understanding BBQ. Once you get the science, you never need another tutorial." data-id="element-301" />
                <FaqItem question="What if I don't like it?" answer="You're covered by our 'Probe Tender' guarantee. Cook your first brisket using the system. If it isn't the juiciest, most tender meat you've ever tasted, email us for a full refund — and you keep everything." data-id="element-302" />
              </div>
            </motion.div>
          </AnimatedSection>
        </div>
      </section>

      {/* SECTION 8: THE GUARANTEE */}
      <section className="py-20 px-6" style={{
      backgroundColor: '#0d0a06'
    }} data-id="element-303">
        <div className="max-w-3xl mx-auto" data-id="element-304">
          <AnimatedSection data-id="element-305">
            <motion.div variants={fadeUp} className="rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" style={{
            background: 'linear-gradient(135deg, #1a1008 0%, #150f06 100%)',
            border: '1px solid rgba(201,168,76,0.3)'
          }} data-id="element-306">
              {/* Gold corner accent */}
              <div className="absolute top-0 left-0 right-0 h-1" style={{
              background: 'linear-gradient(90deg, transparent, #c9a84c, transparent)'
            }} data-id="element-307" />

              <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{
              background: 'linear-gradient(135deg, rgba(201,168,76,0.2), rgba(201,168,76,0.05))',
              border: '2px solid rgba(201,168,76,0.4)'
            }} data-id="element-308">
                <ShieldIcon className="w-10 h-10" style={{
                color: '#c9a84c'
              }} data-id="element-309" />
              </div>

              <h2 className="text-2xl md:text-4xl font-bold mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#c9a84c'
            }} data-id="element-310">
                The "Probe Tender" Guarantee
              </h2>
              <p className="text-sm uppercase tracking-widest mb-6" style={{
              color: '#b8a99a',
              fontFamily: 'Lato, sans-serif'
            }} data-id="element-311">
                60-Day, No-Questions-Asked
              </p>

              <p className="text-base md:text-lg leading-relaxed mb-6" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-312">
                Cook your first brisket using my system. If it isn't the{' '}
                <strong style={{
                color: '#faa307'
              }} data-id="element-313">
                  juiciest, most tender meat you've ever tasted
                </strong>
                , email me. I'll refund every penny AND you can keep the $562
                worth of materials.
              </p>

              <p className="text-xl font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-314">
                No questions asked. No hoops to jump through.
              </p>
            </motion.div>
          </AnimatedSection>
        </div>
      </section>

      {/* SECTION 9: FINAL CLOSE — TWO PATHS */}
      <section className="grain-overlay py-20 px-6" style={{
      backgroundColor: '#110e08'
    }} data-id="element-315">
        <div className="max-w-4xl mx-auto" data-id="element-316">
          <AnimatedSection data-id="element-317">
            <motion.div variants={fadeUp} className="text-center mb-14" data-id="element-318">
              <p className="section-label mb-3" data-id="element-319">Your Choice</p>
              <h2 className="text-3xl md:text-5xl font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#fdf0d5'
            }} data-id="element-320">
                Two Paths. One Decision.
              </h2>
              <div className="divider-flame mt-6" data-id="element-321" />
            </motion.div>

            <motion.div variants={staggerContainer} className="grid md:grid-cols-2 gap-6 mb-14" data-id="element-322">
              {/* Path A - Bad */}
              <motion.div variants={fadeUp} className="rounded-2xl p-8" style={{
              background: 'linear-gradient(135deg, #1a0808 0%, #150606 100%)',
              border: '1px solid rgba(180,30,30,0.3)'
            }} data-id="element-323">
                <div className="flex items-center gap-3 mb-6" data-id="element-324">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: 'rgba(180,30,30,0.2)',
                  border: '1px solid rgba(180,30,30,0.4)'
                }} data-id="element-325">
                    <XIcon className="w-5 h-5 text-red-500" data-id="element-326" />
                  </div>
                  <h3 className="text-xl font-bold" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#fdf0d5'
                }} data-id="element-327">
                    Path A: Keep Guessing
                  </h3>
                </div>
                <ul className="space-y-3" data-id="element-328">
                  <li className="flex items-start gap-3" data-id="element-329">
                    <XIcon className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" data-id="element-330" />
                    <span style={{
                    fontFamily: 'Lato, sans-serif',
                    color: '#b8a99a',
                    fontSize: '0.95rem'
                  }} data-id="element-331">
                      Keep wasting $150+ on expensive meat that comes out dry
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-332">
                    <XIcon className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" data-id="element-333" />
                    <span style={{
                    fontFamily: 'Lato, sans-serif',
                    color: '#b8a99a',
                    fontSize: '0.95rem'
                  }} data-id="element-334">
                      Feel that "Pitmaster Envy" every time you see a pro result
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-335">
                    <XIcon className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" data-id="element-336" />
                    <span style={{
                    fontFamily: 'Lato, sans-serif',
                    color: '#b8a99a',
                    fontSize: '0.95rem'
                  }} data-id="element-337">
                      Sacrifice every Saturday to the BBQ gods and still fail
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-338">
                    <XIcon className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" data-id="element-339" />
                    <span style={{
                    fontFamily: 'Lato, sans-serif',
                    color: '#b8a99a',
                    fontSize: '0.95rem'
                  }} data-id="element-340">
                      Remain "the guy with the expensive grill who can't cook"
                    </span>
                  </li>
                </ul>
              </motion.div>

              {/* Path B - Good */}
              <motion.div variants={fadeUp} className="rounded-2xl p-8" style={{
              background: 'linear-gradient(135deg, #0d1a08 0%, #081506 100%)',
              border: '1px solid rgba(201,168,76,0.3)'
            }} data-id="element-341">
                <div className="flex items-center gap-3 mb-6" data-id="element-342">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: 'rgba(201,168,76,0.2)',
                  border: '1px solid rgba(201,168,76,0.4)'
                }} data-id="element-343">
                    <FlameIcon className="w-5 h-5" style={{
                    color: '#faa307'
                  }} data-id="element-344" />
                  </div>
                  <h3 className="text-xl font-bold" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#fdf0d5'
                }} data-id="element-345">
                    Path B: Master the Flame
                  </h3>
                </div>
                <ul className="space-y-3" data-id="element-346">
                  <li className="flex items-start gap-3" data-id="element-347">
                    <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                    color: '#4ade80'
                  }} data-id="element-348" />
                    <span style={{
                    fontFamily: 'Lato, sans-serif',
                    color: '#fdf0d5',
                    fontSize: '0.95rem'
                  }} data-id="element-349">
                      Spend less than a single rack of ribs to gain a lifetime
                      skill
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-350">
                    <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                    color: '#4ade80'
                  }} data-id="element-351" />
                    <span style={{
                    fontFamily: 'Lato, sans-serif',
                    color: '#fdf0d5',
                    fontSize: '0.95rem'
                  }} data-id="element-352">
                      Become the hero of every backyard party for the rest of
                      your life
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-353">
                    <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                    color: '#4ade80'
                  }} data-id="element-354" />
                    <span style={{
                    fontFamily: 'Lato, sans-serif',
                    color: '#fdf0d5',
                    fontSize: '0.95rem'
                  }} data-id="element-355">
                      Cook competition-quality BBQ on the grill you already own
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-356">
                    <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                    color: '#4ade80'
                  }} data-id="element-357" />
                    <span style={{
                    fontFamily: 'Lato, sans-serif',
                    color: '#fdf0d5',
                    fontSize: '0.95rem'
                  }} data-id="element-358">
                      Backed by a 60-day guarantee — zero risk, all reward
                    </span>
                  </li>
                </ul>
              </motion.div>
            </motion.div>

            {/* Final CTA */}
            <motion.div variants={fadeUp} className="text-center" data-id="element-359">
              <a href="https://www.versastorex.com/cart/42212433526864:1" onClick={handleAddToCart} className="btn-gold text-lg md:text-2xl px-10 py-6 rounded-xl inline-flex items-center gap-4 gold-glow mb-6" data-id="element-360">
                <FlameIcon className="w-7 h-7" data-id="element-361" />
                YES — MASTER THE SMOKE. ACCESS NOW FOR $9.99 AUD
                <ArrowRightIcon className="w-7 h-7" data-id="element-362" />
              </a>

              <div className="flex flex-wrap items-center justify-center gap-6 mb-8" data-id="element-363">
                <div className="flex items-center gap-2" style={{
                color: '#b8a99a',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.85rem'
              }} data-id="element-364">
                  <LockIcon className="w-4 h-4" data-id="element-365" />
                  <span data-id="element-366">Secure Checkout</span>
                </div>
                <div className="flex items-center gap-2" style={{
                color: '#b8a99a',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.85rem'
              }} data-id="element-367">
                  <ShieldIcon className="w-4 h-4" data-id="element-368" />
                  <span data-id="element-369">60-Day Guarantee</span>
                </div>
                <div className="flex items-center gap-2" style={{
                color: '#b8a99a',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.85rem'
              }} data-id="element-370">
                  <CheckIcon className="w-4 h-4" data-id="element-371" />
                  <span data-id="element-372">Instant Access</span>
                </div>
              </div>

              <div className="inline-flex items-center gap-3 px-6 py-3 rounded-xl" style={{
              backgroundColor: '#1a1008',
              border: '1px solid #2e2010'
            }} data-id="element-373">
                <p className="text-sm font-bold uppercase tracking-wider" style={{
                color: '#e85d04',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-374">
                  Price increases in:
                </p>
                <CountdownTimer initialSeconds={862} compact data-id="element-375" />
              </div>
            </motion.div>
          </AnimatedSection>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-10 px-6 text-center" style={{
      backgroundColor: '#0d0a06',
      borderTop: '1px solid #1a1008'
    }} data-id="element-376">
        <div className="max-w-3xl mx-auto" data-id="element-377">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-378">
            <FlameIcon className="w-5 h-5 text-amber-500" data-id="element-379" />
            <span className="text-lg font-bold" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#c9a84c',
            letterSpacing: '0.1em'
          }} data-id="element-380">
              THE BACKYARD PITMASTER
            </span>
          </div>
          <p className="text-xs mb-4" style={{
          color: '#b8a99a',
          fontFamily: 'Lato, sans-serif',
          lineHeight: 1.7
        }} data-id="element-381">
            Results may vary. Testimonials are from real customers but
            individual results depend on effort, experience, and grill setup.
            This product is a digital download. No physical product will be
            shipped.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-xs" style={{
          color: '#b8a99a',
          fontFamily: 'Lato, sans-serif'
        }} data-id="element-382">
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-383">
              Privacy Policy
            </a>
            <span data-id="element-384">·</span>
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-385">
              Terms of Service
            </a>
            <span data-id="element-386">·</span>
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-387">
              Contact Support
            </a>
          </div>
          <p className="text-xs mt-4" style={{
          color: '#2e2010',
          fontFamily: 'Lato, sans-serif'
        }} data-id="element-388">
            © 2026 The Backyard Pitmaster. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}